import { render, staticRenderFns } from "./UserFavouriteProducts.vue?vue&type=template&id=c82bea26&scoped=true"
import script from "./UserFavouriteProducts.vue?vue&type=script&lang=js"
export * from "./UserFavouriteProducts.vue?vue&type=script&lang=js"
import style0 from "./UserFavouriteProducts.vue?vue&type=style&index=0&id=c82bea26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82bea26",
  null
  
)

export default component.exports